import type { ShareButtonProps, SocialShareType } from "@product/scmp-sdk";
import { findFirstNonEmptyString } from "@product/scmp-sdk";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { popupArticle20ShareMenuContent$key } from "scmp-app/queries/__generated__/popupArticle20ShareMenuContent.graphql";

import {
  Header,
  StyledIconEmail,
  StyledIconFacebook,
  StyledIconTelegram,
  StyledIconTwitter,
  StyledIconWhatsapp,
  StyledMenuItem,
  StyledPaper,
  StyledShareButton,
} from "./styles";

export type Props = {
  className?: string;
  reference: popupArticle20ShareMenuContent$key;
} & Pick<ShareButtonProps, "position">;

export const Article20ShareMenuPopup = forwardRef<HTMLDivElement, Props>(
  ({ className, position, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment popupArticle20ShareMenuContent on Content {
          entityId
          urlAlias
          shortUrl
          headline
          socialHeadline
        }
      `,
      reference_,
    );

    const renderMenuItems = () => {
      const socialShareTypes: SocialShareType[] = [
        "facebook",
        "twitter",
        "whatsapp",
        "telegram",
        "email",
      ];
      return socialShareTypes.map(type => (
        <StyledMenuItem key={type} disableRipple>
          <StyledShareButton
            extraProps={{
              overrideIcons: {
                email: StyledIconEmail,
                facebook: StyledIconFacebook,
                telegram: StyledIconTelegram,
                twitter: StyledIconTwitter,
                whatsapp: StyledIconWhatsapp,
              },
            }}
            position={position}
            relativeUrl={content.urlAlias}
            shortUrl={content.shortUrl ?? ""}
            style={{
              /* stylelint-disable */
              backgroundColor: "transparent",
              mobilePadding: 0,
              padding: 0,
              size: 36,
              /* stylelint-enable */
            }}
            title={findFirstNonEmptyString(content.socialHeadline, content.headline)}
            type={type}
            utm={{
              campaign: content.entityId,
              medium: "share_widget",
            }}
            showLabel
          />
        </StyledMenuItem>
      ));
    };
    return (
      <StyledPaper className={className} ref={reference}>
        <Header>Share</Header>
        {renderMenuItems()}
      </StyledPaper>
    );
  },
);

Article20ShareMenuPopup.displayName = "Article20ShareMenuPopup";
